import { Collaboration } from '@/redux/collaborationsApi'
import { sports } from '@/config'

export const calculateEarnings = (collaborations: Collaboration[]) => {
  const completedCollaborations = collaborations.filter((collaboration) =>
    ['paid', 'pending'].includes(collaboration.paymentStatus),
  )

  const totalEarnings = completedCollaborations.reduce(
    (total, campaign) => total + Number(campaign.paymentAmount) || 0,
    0,
  )

  const pendingPayments = completedCollaborations
    .filter((collaboration) => collaboration.paymentStatus !== 'paid')
    .reduce((total, collaboration) => total + Number(collaboration.paymentAmount) || 0, 0)

  const paidPayments = collaborations
    .filter((collaboration) => collaboration.paymentStatus === 'paid')
    .reduce((total, collaboration) => total + Number(collaboration.paymentAmount) || 0, 0)

  return {
    totalEarnings,
    pendingPayments,
    paidPayments,
  }
}

export const formatPayoutDisplay = (collaboration: Collaboration): string => {
  if (collaboration.paymentType === 'custom') {
    return collaboration.customPaymentTerms || 'Custom payment terms'
  }

  // For all other payment types, show the dollar amount
  if (collaboration.paymentAmount) {
    const amount = Number(collaboration.paymentAmount)
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount)
  }

  return 'TBD'
}

export const getSportNameById = (id: number): string => {
  const sport = sports.find((sport) => sport.id === id)
  return sport?.name || `Sport ${id}`
}

export const getSportIdByName = (name: string): number | undefined => {
  const sport = sports.find((sport) => sport.name === name)
  return sport?.id
}

export const convertSportIdsToNames = (sportIds: number[]): string[] => {
  return sportIds.map((id) => getSportNameById(id))
}

export const convertSportNamesToIds = (sportNames: string[]): number[] => {
  return sportNames
    .map((name) => getSportIdByName(name))
    .filter((id): id is number => id !== undefined)
}
